import {
  getIsLocalEnvironment,
  getIsNonProductionEnvironment,
} from '@shared/getEnvironmentKind';
import { consoleLogger } from '@shared/logging/consoleLogger';
import { getBaseDomain } from './domain/getBaseDomain';

export const resolveEnvironmentCustomHost = () => {
  const customHostPerEnvironment = {
    Utiq: 'customUtiqHost',
  };

  const customEnvironmentHost =
    // TODO: Post-separation refactor required https://utiq.atlassian.net/browse/UPDS-771
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.Utiq?.config?.[customHostPerEnvironment['Utiq']];

  if (
    customEnvironmentHost !== undefined &&
    customEnvironmentHost !== null &&
    customEnvironmentHost !== ''
  ) {
    return customEnvironmentHost;
  }

  return null;
};

//TODO: someone please explain to me what the difference is meant to be between these functions, so we can document it better

export const getUtiqHost = () => {
  const customUtiqHost = resolveEnvironmentCustomHost();
  if (customUtiqHost) {
    consoleLogger.logDebug(
      `Returning utiqHost from the customUtiqHost config entry: ${customUtiqHost}...`,
    );
    return customUtiqHost;
  }
  const hostSplit = window.location.host.split('.');
  // TODO: We cannot leave this as somebody may use more nested subdomains than 1
  if (hostSplit.length > 2) {
    hostSplit.shift();
  }
  if (
    window.location.origin.includes('//utiq-test.') ||
    getIsLocalEnvironment()
  ) {
    hostSplit.unshift('utiq-test');
  } else if (
    window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST &&
    typeof window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST === 'string' &&
    window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST.indexOf('https://tmi.') === 0
  ) {
    hostSplit.unshift('tmi');
  } else {
    hostSplit.unshift('utiq');
  }
  const utiqHost = `https://${hostSplit.join('.').replace(':8080', '')}`;

  consoleLogger.logDebug(`Returning utiqHost ${utiqHost}...`);
  return utiqHost;
};

export const getHostname = () => {
  const customUtiqHost = resolveEnvironmentCustomHost();
  if (customUtiqHost) {
    const [, hostname] = customUtiqHost.split('://');
    if (hostname) {
      consoleLogger.logDebug(
        `Returning hostname from the customUtiqHost config entry: ${hostname}...`,
      );
      return hostname;
    }
  }
  const hostname = getIsLocalEnvironment()
    ? `utiq-test.${window.location.hostname}`
    : window.location.hostname;

  consoleLogger.logDebug(`Returning extracted hostname: ${hostname}...`);
  return hostname;
};

export const getHost = () => {
  const getUtiqHost = (customUtiqHost: string | null, baseDomain: string) => {
    if (customUtiqHost) {
      consoleLogger.logDebug(
        `Custom Utiq host config entry detected. Utiq host: ${customUtiqHost}`,
      );
      return customUtiqHost;
    }
    let utiqSubdomain = 'utiq';

    if (getIsNonProductionEnvironment()) {
      utiqSubdomain = 'utiq-test';
    } else if (
      window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST &&
      typeof window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST === 'string' &&
      window.IDCONNECT_CONFIG?.IDCONNECT_API_HOST.indexOf('https://tmi.') === 0
    ) {
      utiqSubdomain = 'tmi';
    }
    const utiqHost = `https://${utiqSubdomain}.${baseDomain}`;
    consoleLogger.logDebug(`Extracted Utiq host: ${utiqHost}`);
    return utiqHost;
  };

  consoleLogger.logDebug(
    `Is this a local environment origin: ${getIsLocalEnvironment()}`,
  );

  consoleLogger.logDebug(
    `Is this a local or UAT environment the origin: ${getIsNonProductionEnvironment()}`,
  );

  const urlParamsHost = new URLSearchParams(window.location.search).get('host');
  consoleLogger.logDebug(`URL parameter host: ${urlParamsHost}`);

  const customUtiqHost = resolveEnvironmentCustomHost();
  const baseDomain = customUtiqHost
    ? getBaseDomain(customUtiqHost)
    : getBaseDomain(window.location.hostname);
  const host =
    getIsNonProductionEnvironment() && urlParamsHost
      ? urlParamsHost
      : baseDomain;
  consoleLogger.logDebug(`Extracted host: ${host}`);

  return {
    host,
    utiqHost: getUtiqHost(customUtiqHost, baseDomain),
  };
};
